import { Bucket } from '../../services/executionStatsService';

/**
 * Links into the Activity Monitor's Run log.
 *
 * The Run log keeps every filter in the query string, so any count or run
 * elsewhere in the app can open the same view. This is the one place that
 * writes those parameters; RunLog is the one place that reads them.
 */

export const RUN_LOG_PATH = '/monitoringDashboard';

export interface RunLogView {
    /** A workflow's template code; a version suffix is kept. */
    code?: string | null;
    /** A campaign id. Only one of code and campaignId is applied. */
    campaignId?: string | null;
    /** false lists one version of `code` only. Grouped is the default. */
    groupVersions?: boolean;
    bucket?: Bucket | null;
    /** An explicit [from, to) window, overriding the preset range. */
    from?: string | null;
    to?: string | null;
    /** A run to open in the drawer. */
    run?: string | null;
}

const VERSION_SUFFIX = /_\d{8}T\d{6}$/;

/** A template code without its _YYYYMMDDTHHMMSS version, as the API groups it. */
export const baseCode = (code: string): string => code.replace(VERSION_SUFFIX, '');

export const runLogParams = (view: RunLogView): URLSearchParams => {
    const params = new URLSearchParams({ tab: 'runs' });
    if (view.campaignId) params.set('campaign', view.campaignId);
    else if (view.code) {
        params.set('code', view.code);
        if (view.groupVersions === false) params.set('versions', 'separate');
    }
    if (view.bucket) params.set('bucket', view.bucket);
    if (view.from && view.to) {
        params.set('from', view.from);
        params.set('to', view.to);
    }
    if (view.run) params.set('run', view.run);
    return params;
};

/** An href for the app's hash router, usable outside router context. */
export const runLogHref = (view: RunLogView): string => `#${RUN_LOG_PATH}?${runLogParams(view).toString()}`;
